<template>
  <v-layout row class="my-4 pa-2">
    <v-data-table
      :headers="headers"
      :items="sponsorsTaskList"
      class="elevation-1 wrap"
      :pagination.sync="pagination"
      :total-items="totalItemsInTable"
      :loading="loading"
      item-key="id"
      disable-initial-sort
    >
      <template slot="items" slot-scope="props">
        <td class="py-4">{{props.item.title}}</td>

        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn color="lime"
              :disabled="!isWriteAvailable"
              fab flat
              slot="activator"
              @click.stop="editItem(props.item)"
            >
              <v-icon>create</v-icon>
            </v-btn>
            <span>Edit</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              color="error"
              :disabled="!isWriteAvailable"
              fab flat
              slot="activator"
              @click.stop="deleteItem(props.item)"
            >
              <v-icon>delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
        </td>
      </template>
      <template slot="pageText" slot-scope="{}">
        Page {{pagination.page}} of {{totalTasksPages}}
      </template>
    </v-data-table>
    <v-flex offset-xs1>
      <v-layout column justify-start align-content-center>
        <v-flex xs1>
          <v-text-field
            append-icon="search"
            label="Search by Title"
            v-model="filterTitle"
          />
        </v-flex>
        <v-flex>
          <v-btn color="normal" @click="reset">Reset</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import lodash from 'lodash'
import { equals } from 'ramda'
import { timeSettings } from '@/modules/settings/'
import { mapActions, mapGetters } from 'vuex'
import mixins from '@/utils/mixins'

export default {
  name: 'TableSponsorTask',
  mixins: [mixins.isWriteAvailable],
  data () {
    return {
      headers: [
        {text: 'Title', value: 'title', search: true, sortable: true, width: 300},
        {text: 'Edit', search: false, align: 'center', sortable: false, width: 100},
        {text: 'Delete', align: 'center', search: false, sortable: false, width: 100}
      ],
      pagination: {
        rowsPerPage: 5,
        sortBy: null,
        descending: false
      },
      filterTitle: '',
      loading: true,
      // DON'T DELETE! need for isWriteAvailable mixin
      scopeForWrite: 'sponsors:write'
    }
  },
  computed: {
    ...mapGetters([
      'sponsorsTaskList',
      'totalTasksPages',
      'totalTasksItems'
    ]),
    totalItemsInTable () {
      return this.totalTasksItems || (this.totalTasksItems * this.pagination.rowsPerPage)
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getTasks()
      },
      deep: true
    },
    filterTitle () {
      this.getTasks()
    },
  },
  methods: {
    ...mapActions(['removeSponsorTask', 'fetchSponsorTasksList']),
    editItem (item) {
      this.$bus.$emit('editSponsorTask', item)
    },
    async deleteItem (item) {
      await this.removeSponsorTask(item.id)
      this.getTasks()
    },
    getTasks: lodash.debounce(async function () {
      this.loading = true
      const {sortBy, descending, page, rowsPerPage} = this.pagination
      let itemsOnPage = equals(rowsPerPage, -1) ? this.totalTypesItems : rowsPerPage
      const sort = descending ? 'Desc' : 'Asc'
      const name = sortBy ? sortBy[0].toUpperCase() + sortBy.slice(1) : null
      const newPage = page - 1
      const pageCheck = newPage > 0 ? newPage : 0
      const getParams = {
        page: pageCheck,
        itemsOnPage,
        filter: this.filterTitle,
        sort,
        name
      }
      await this.fetchSponsorTasksList(getParams)
      this.loading = false
    }, timeSettings.delayTime),
    reset () {
      this.filterTitle = ''
      this.pagination.sortBy = null
      this.pagination.descending = false
      this.getTasks()
    }
  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/pages/Sponsors/Settings/SponsorsTasks/TableSponsorTask.vue